export const ApplicationConstant = {
    ApplicationID : 30,
    clientId : 17,
    organizationId: 4,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 5
}